module Elma.Bindings {

    export interface IFormatNumber {
        locale: string,
        observable: KnockoutObservable<number>,
        digits?: number

    }

    export class FormatNumber {

        private updateValues = (element: any, valueAccessor: () => IFormatNumber, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) => {

            if (!bindingContext) {
                return;
            }

            var value = ko.unwrap(valueAccessor());

            if (value.locale) {
                var shortDigits = typeof value.digits != "undefined" ? value.digits : 2;
                if (ko.isObservable(value.observable)) {
                    var currentValue: number = Number(value.observable());
                    element.innerHTML = currentValue.toLocaleString(value.locale, { minimumFractionDigits: shortDigits });
                }
                else {
                    console.warn("remember to define observable in your formatNumber binding");
                }
            }
            else {
                console.warn("remember to define locale in your formatNumber binding");
            }

        };

        public init = this.updateValues;
        public update = this.updateValues;

    }

    ko.bindingHandlers['formatNumber'] = new FormatNumber();

}